import {RouteRecordRaw} from "vue-router";

export const inventoryRoutes: RouteRecordRaw = {
  path: 'inventory',
  name: 'Inventory',
  meta: {requiresAuth: true, feature: 'inventory'},
  component: () => import('@/layouts/InventoryLayout.vue'),
  children: [
    {
      path: 'items',
      name: 'Products',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'ProductsDashboard',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/products/Items.vue'),
        },
        {
          path: 'create',
          name: 'CreateItem',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/products/Item.vue'),
        },
        {
          path: ':productID',
          name: 'ItemDetails',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/products/Item.vue'),
        },
      ],
    },
    {
      path: 'packages',
      name: 'Packages',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'ListPackages',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/packages/Packages.vue'),
        },
        {
          path: 'create',
          name: 'CreatePackage',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/packages/Package.vue'),
        },
        {
          path: ':packageID',
          name: 'PackageDetails',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/packages/Package.vue'),
        },
      ],
    },
    {
      path: 'providers',
      name: 'Providers',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'ListProviders',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/providers/Providers.vue'),
        },
        {
          path: 'create',
          name: 'CreateProvider',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/providers/Provider.vue'),
        },
        {
          path: ':providerID',
          name: 'ProviderDetails',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/providers/Provider.vue'),
        },
      ],
    },
    {
      path: 'categories',
      name: 'Categories',
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'ListCategories',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/categories/Categories.vue'),
        },
        {
          path: 'create',
          name: 'CreateCategory',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/categories/Category.vue'),
        },
        {
          path: ':categoryID',
          name: 'CategoryDetails',
          meta: {requiresAuth: true},
          component: () => import('@/features/inventory/views/categories/Category.vue'),
        },
      ],
    },
  ],
};
